import {useEffect} from "react";
import {useLocation} from "react-router-dom";


export default function AutoScroll({children}) {
    const location = useLocation();

    useEffect(() => {
        let focus_auto_section = document.getElementById("main-container")
        if (focus_auto_section) {
            focus_auto_section.scrollIntoView()
        }
    }, [location]);

    return (
        <>
            {children}
        </>
    )
}